import {
  AuthenticationControllerApi,
  BoardControllerApi,
  BrandControllerApi,
  BrandBoardControllerApi,
  CategoryControllerApi,
  CollectionControllerApi,
  ProductControllerApi,
  PromoCodeControllerApi,
  ReferralControllerApi,
  RetailerControllerApi,
  ViewControllerApi,
  ValidationControllerApi,
  Configuration,
  TradeShowControllerApi,
  CustomAssortmentControllerApi,
  PaymentControllerApi,
  InvoiceControllerApi,
  OnboardingControllerApi,
  OrderControllerApi,
  NavigationV2ControllerApi
} from './generated'
import env from '../env'
import customAxios from '../http-interceptors'

export const apiConfiguration = new Configuration({
  basePath: env.apiUrl(),
  baseOptions: {
    axios: customAxios
  }
})

// Helper function to unwrap Axios responses
function unwrapResponse(promise) {
  return promise.then((response) => {
    // Check if this is an Axios response (has data property and other axios properties)
    if (
      response &&
      typeof response === 'object' &&
      response.data !== undefined &&
      (response.status !== undefined || response.headers !== undefined)
    ) {
      return response.data
    }
    return response
  })
}

// Function to create a proxy that unwraps responses
function createUnwrappingProxy(api) {
  return new Proxy(api, {
    get(target, prop) {
      const original = target[prop]
      if (typeof original === 'function') {
        // For methods, return a function that unwraps the response
        return function (...args) {
          return unwrapResponse(original.apply(target, args))
        }
      }
      // For non-methods, return the original property
      return original
    }
  })
}

// Create wrapped API instances
export const AuthenticationApi = createUnwrappingProxy(
  new AuthenticationControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const BoardApi = createUnwrappingProxy(new BoardControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const BrandApi = createUnwrappingProxy(new BrandControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const BrandBoardApi = createUnwrappingProxy(
  new BrandBoardControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const CategoryApi = createUnwrappingProxy(new CategoryControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const CollectionApi = createUnwrappingProxy(
  new CollectionControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const ProductApi = createUnwrappingProxy(new ProductControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const PromoCodeApi = createUnwrappingProxy(
  new PromoCodeControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const ReferralApi = createUnwrappingProxy(new ReferralControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const RetailerApi = createUnwrappingProxy(new RetailerControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const ViewApi = createUnwrappingProxy(new ViewControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const ValidationApi = createUnwrappingProxy(
  new ValidationControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const TradeShowApi = createUnwrappingProxy(
  new TradeShowControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const CustomAssortmentApi = createUnwrappingProxy(
  new CustomAssortmentControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const PaymentApi = createUnwrappingProxy(new PaymentControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const InvoiceApi = createUnwrappingProxy(new InvoiceControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const OrdersApi = createUnwrappingProxy(new OrderControllerApi(apiConfiguration, env.apiUrl(), customAxios))
export const OnboardingApi = createUnwrappingProxy(
  new OnboardingControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
export const NavigationApi = createUnwrappingProxy(
  new NavigationV2ControllerApi(apiConfiguration, env.apiUrl(), customAxios)
)
